import { jsx as t, jsxs as m } from "react/jsx-runtime";
import a from "./index.es5650.js";
import n from "classnames";
import { ColorIndicator as d } from "./index.es26.js";
import { BaseHeader as l } from "./index.es5536.js";
const f = "color-indicator-header", T = ({
  entityColor: e,
  displayName: r,
  gridDensity: i,
  testId: o = f,
  ...c
}) => {
  const s = n(a.root, a[i]);
  return /* @__PURE__ */ t(l, { displayName: r, testId: o, ...c, children: /* @__PURE__ */ m("div", { className: s, "data-testid": o + "-container", children: [
    /* @__PURE__ */ t(d, { entityColor: e, testId: o + "-color-indicator" }),
    r
  ] }) });
};
export {
  T as ColorIndicatorHeader,
  f as DEFAULT_COLOR_INDICATOR_HEADER_TESTID
};
//# sourceMappingURL=index.es635.js.map
